import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useGetDriversBreakdownMutation } from "../../../store/api/lumi/drivers";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { getType } from "../../../utils/date";
import { debounce } from "lodash";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import OverallAverageScoreChart from "./AverageScoreOverTimeChart";
import { formatDateToUtc } from "../../../utils/formatDate";
import { useGetConceptsFiltersMutation } from "../../../store/api/lumi/concepts";

const AverageScoreOverTime = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [averageScore, setAverageScore] = useState([]);
    const [getDriver] = useGetDriversBreakdownMutation();
    const [getVolumes] = useGetConceptsFiltersMutation();
    const metadata = props.metaDataQu.metaData;
    const metadataNumberFields = metadata?.filter((field) => field.type === "number");
    const metadataScoreFields = metadata?.filter((field) => field.type === "score");
    const { smoothLine } = props;
    const conceptFilters = useMemo(
        () => JSON.stringify(getConceptFilter(props)),
        [props]
    );

    const {
        id,
        filters,
        setFilterDocCount,
    } = props;

    useEffect(() => {
        if (metadataScoreFields.length === 0) {
            props.setSelectedFieldDriverName(metadataNumberFields[0].name);
        } else {
            props.setSelectedFieldDriverName(metadataScoreFields[0].name);
        }
    }, [metadataScoreFields.length, metadataNumberFields.length]);

    async function getDriversData() {
        try {
            setIsLoading(true);
            const { data: dataConcepts } = await getDriver({
                id: props.id,
                score_field: props.selectedFieldDriverName,
                concept_selector: JSON.parse(conceptFilters),
                filter: props.filters,
                match_type: getType(props.seletctedType),
                breakdowns: [{ name: props.selectedDateName, interval: props.interval }],
            });

            setAverageScore(
                dataConcepts[0].buckets.map((value) => ({
                    label: formatDateToUtc(value.label, dataConcepts[0].breakdown.interval),
                    average: value?.drivers[0]?.baseline ?? 0,
                }))
            );
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (props.selectedFieldDriverName) {
            setIsLoading(true);
            const debouncedGetVolume = debounce(getDriversData, 1000);
            debouncedGetVolume();

            return () => {
                debouncedGetVolume.cancel();
            };
        }
    }, [
        props.selectedFieldDriverName,
        props.filters,
        props.getDriversBreakdown,
        props.seletctedType,
        props.selectedDateName,
        props.interval,
        props.conceptTypeDay,
        props.selectedLocalConcepts,
        props.conceptList,
    ]);

    const getConcepts = useCallback(async () => {

        const { data: dataConcepts } = await getVolumes({
            id,
            concept_selector: JSON.parse(conceptFilters),
            filter: filters,
        });
        setFilterDocCount(dataConcepts.filter_count);
    }, [conceptFilters, filters, getVolumes, id, setFilterDocCount]);

    useEffect(() => {
        const debouncedGetConcepts = debounce(getConcepts, 1000);

        debouncedGetConcepts();

        return () => {
            debouncedGetConcepts.cancel();
        };
    }, [getConcepts]);


    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }

    return (
        <div  style={{ height: props.widget.layout.h * 39 - 150 }}  onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault()
        }}>
            <OverallAverageScoreChart
                data={averageScore}
                value={props.selectedFieldDriverName}
                smoothLine={smoothLine}
            />
        </div>
    );
};

export default AverageScoreOverTime;
